<template>
  <div>
    <el-form
      :model="activityObject"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="活动ID" prop="activity_id" v-show="false">
        <el-input v-model="activityObject.activity_id" disabled></el-input>
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input
          v-model="activityObject.title"
          maxlength="30"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="编号" prop="number">
        <el-input v-model="activityObject.number"></el-input>
      </el-form-item>

      <el-form-item label="详情">
        <div ref="editorElem"></div>
        <tinymce v-model="activityObject.detial"></tinymce>
      </el-form-item>

      <el-form-item label="图片">
        <el-upload
          class="avatar-uploader"
          :action="ossAction"
          :show-file-list="false"
          :http-request="uploadOSSRequest"
          :before-upload="beforeImageUpload"
        >
          <img
            v-if="activityObject.img_url"
            :src="activityObject.img_url"
            class="avatar"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过500kb
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="视频">
        <el-upload
          class="avatar-uploader"
          action="ossAction"
          :http-request="videoUploadOSSRequest"
          :show-file-list="false"
          :before-upload="beforeVideoUpload"
        >
          <video
            v-if="activityObject.media"
            :src="activityObject.media"
            class="avatar"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip">
            只能上传mp4文件，且不超过200M
            <el-popover placement="right" width="800" trigger="click">
              <el-table :data="activityObjectVideoList" @row-click="chooseVideo">
                <el-table-column
                  width="800"
                  property="address"
                  label="地址"
                ></el-table-column>
              </el-table>
              <el-button slot="reference" @click="getActivityObjectVideoList()">选择视频</el-button>
            </el-popover>
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="虚拟票数">
        <el-input v-model="activityObject.virtual_number"></el-input>
      </el-form-item>
      <el-form-item>
        <!-- <el-button type="primary" @click="createActivityObject('ruleForm')"
          >立即创建</el-button> -->
        <el-button
          size="small"
          type="primary"
          @click="
            create == false ? updateActivityObject() : createActivityObject()
          "
          :loading="updateLoading"
          >确 定</el-button
        >
        <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
      </el-form-item>
    </el-form>

    <div class="hides" v-if="isshow">
      <i style="margin-top: 20px; font-size: 40px" class="el-icon-loading"> </i
      ><br />
      正在上传
    </div>
  </div>
</template>

<script>
import tinymce from '@/components/tinymce.vue';

import {
  beforeImageUpload,
  beforeVideoUpload,
  uploadOSSRequest,
  getAliyunOssToken,
} from "@/api/common";

import {
  createActivityObject,
  updateActivityObject,
  getActivityObjectInfo,
  getActivityObjectVideoList,
} from "@/api/activity";
import { PrefixSource } from "webpack-sources";

export default {
  data: function () {
    return {
      isshow: false,
      ossAction: "",
      ossData: {},
      create: true,
      list: [],
      dialogVisible: false,
      loading: false,
      aliyunOssToken: "",
      updateLoading: false,
      total: 0,
      editor: null,
      activityObjectVideoList: [],
      activityObject: {
        id: 0,
        activity_id: 0,
        img_url: "",
        title: "",
        detial: "",
        media: "",
        number: 0,
        virtual_number: 0,
      },
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        activity_id: [
          { required: true, message: "请输入活动ID", trigger: "blur" },
        ],
        number: [{ required: true, message: "请输入编号", trigger: "blur" }],
        img_url: [{ required: true, message: "请上传图片", trigger: "blur" }],
        media: [{ required: true, message: "请上传视频", trigger: "blur" }],
      },
    };
  },
  components: {
    tinymce,
  },
  created: function () {
    this.activityObject.id = this.$route.query.id;
    if (this.activityObject.id > 0) {
      this.create = false;
      this.getInfo();
    }
  },
  mounted() {
    let activity_id = this.$route.query.activity_id;
    this.activityObject.activity_id = activity_id;
    
  },
  methods: {
    beforeImageUpload(file) {
      beforeImageUpload(file);
    },
    uploadOSSRequest(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          this.activityObject.img_url = fileUrl
        });
      });
    },
    beforeVideoUpload(file) {
      beforeVideoUpload(file);
      this.isshow = true;
    },
    videoUploadOSSRequest(file) {
      getAliyunOssToken({ dir: 'activity/' + this.$route.query.activity_id + '/' }).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          this.activityObject.media = fileUrl;
          this.isshow = false;
        });
      });
    },

    chooseVideo (row) {
      this.activityObject.media = row.address;
    },
    getActivityObjectVideoList() {
      getActivityObjectVideoList({
        id: this.$route.query.activity_id,
      }).then((response) => {
        this.activityObjectVideoList = response.data;
      });
    },
    getInfo() {
      this.loading = true;
      getActivityObjectInfo({
        id: this.activityObject.id,
      }).then((response) => {
        this.activityObject = response.data;
        this.loading = false;
      });
    },
    createActivityObject() {
      this.updateLoading = true;
      createActivityObject(this.activityObject)
        .then((response) => {
          this.updateLoading = false;
          if (response.code == 1) {
            this.$message.success(response.message);
            this.$router.push({
              path: "/activity/object/list",
              query: {
                activity_id: this.$route.query.activity_id,
              },
            });
            this.dialogVisible = false;
          }
        })
        .catch((err) => {
          this.updateLoading = false;
        });
    },
    updateActivityObject() {
      this.updateLoading = true;
      updateActivityObject(this.activityObject)
        .then((response) => {
          this.updateLoading = false;
          if (response.code == 1) {
            this.$message.success(response.message);
            this.$router.push({
              path: "/activity/object/list",
              query: {
                activity_id: this.$route.query.activity_id,
              },
            });
            this.dialogVisible = false;
          }
        })
        .catch((err) => {
          this.updateLoading = false;
        });
    },

    ref() {
      window.history.go(-1);
    },

  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.hides {
  background: #fff;
  width: 100px;
  height: 100px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}
</style>